import type { NoContext } from '~/services/api/contracts/NoContext'
import { FavoritesIndexQuerySchema } from '~/services/api/generated'

// FavoriteStoreIndexRequest::rules
export const FavoritesIndex = (_context: NoContext = {}) => FavoritesIndexQuerySchema
